/* Pointer magnifier for product photos. Mouse and trackpad only; touch devices are left alone.
   It finds the gallery by trying the selectors below. If it does not attach on your theme version,
   right-click a product photo -> Inspect, find the wrapping element, and add its selector to SELECTORS. */
(function () {
  'use strict';

  var SELECTORS = [
    '[data-cl-lens] img',
    'media-gallery img',
    '.product-media img',
    '.product__media img',
    '.product-gallery img'
  ].join(',');

  var ZOOM = 2.2;
  var SIZE = 180;

  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var lens = document.createElement('div');
  lens.className = 'cl-lens';
  lens.setAttribute('aria-hidden', 'true');
  document.body.appendChild(lens);

  function bigSrc(img) {
    var src = img.currentSrc || img.src;
    if (!src) return '';
    // Shopify CDN: ask for a large version so the zoom is sharp.
    return src.replace(/([?&])width=\d+/, '$1width=2400');
  }

  function attach(img) {
    if (img.__clLens) return;
    img.__clLens = true;

    var src = '';
    img.addEventListener('mouseenter', function () {
      src = bigSrc(img);
      lens.style.backgroundImage = 'url("' + src + '")';
      lens.classList.add('is-on');
    });
    img.addEventListener('mouseleave', function () {
      lens.classList.remove('is-on');
    });
    img.addEventListener('mousemove', function (e) {
      var r = img.getBoundingClientRect();
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;
      lens.style.width = lens.style.height = SIZE + 'px';
      lens.style.left = e.clientX - SIZE / 2 + 'px';
      lens.style.top = e.clientY - SIZE / 2 + 'px';
      lens.style.backgroundSize = r.width * ZOOM + 'px ' + r.height * ZOOM + 'px';
      lens.style.backgroundPosition = -(x * ZOOM - SIZE / 2) + 'px ' + -(y * ZOOM - SIZE / 2) + 'px';
    });
  }

  function scan(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll(SELECTORS), attach);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();

  // The gallery re-renders when a variant changes; pick up new images.
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; scan(); });
  }).observe(document.body, { childList: true, subtree: true });
})();